import React from "react";
import { inject, observer } from "mobx-react";
import BaseMLBTrackingAccuracyReportContainer from "./BaseMLBTrackingAccuracyReportContainer";
import NonMLBTrackingAccuracyReportTable from "../components/accuracyReports/NonMLBTrackingAccuracyReportTable";
import IncidentTypes from "../constants/IncidentTypes";
import AAGameActionDropDownContainer from "./AAGameActionDropDownContainer";

class AATrackingAccuracyReportContainer extends React.Component {
  render() {
    const rootStore = this.props.rootStore;
    const description =
      "A real-time pitch-by-pitch data report that monitors the overall quality of data and video systems used for AA games.";

    //May need to create a AATrackingAccruacyRportTable
    const reportTable = (
      <NonMLBTrackingAccuracyReportTable
        data={rootStore.AAGameActionStore.trackingAccuracyReportSource.data}
        gameStatuses={rootStore.veracityStore.gameStatuses}
        canCreateIncident={rootStore.authStore.hasIncidentEdit}
        groupsToShow={rootStore.tableControlsStore.state}
        dropDownContainer={AAGameActionDropDownContainer}
      />
    );
    return (
      <BaseMLBTrackingAccuracyReportContainer
        header="AA Statcast Data & Coaching Video Report"
        description={description}
        reportSource={rootStore.AAGameActionStore.trackingAccuracyReportSource}
        reportTable={reportTable}
        incidentTypesToFetch={[IncidentTypes.AA, IncidentTypes.SYSTEM]}
        showSystemIncidentButton={rootStore.authStore.hasIncidentEdit}
      />
    );
  }
}

export default inject("rootStore")(observer(AATrackingAccuracyReportContainer));
